module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogo2KyrgyzMoe.e41e5448.png";